export default __webpack_public_path__ + "static/media/Magadhi_af_2.1bae0da8.mp3";